import React from "react";
import { Button } from "react-bootstrap";
import EmailStatusIcon from "./EmailIcons";
import {
  getStatusColor,
  getStatusLabel,
  formatEmailTimestamp,
  EMAIL_STATUS,
} from "../utils/emailAutomationHelpers";
import "./EmailCard.css";

const StatusBadge = ({ status }) => {
  const color = getStatusColor(status);
  const label = getStatusLabel(status);

  return (
    <span className="email-activity-card-status">
      <span
        className="email-activity-card-status-dot"
        style={{ backgroundColor: color }}
      />
      <span style={{ color }}>{label}</span>
    </span>
  );
};

/**
 * Computes helper text from email log data based on status.
 */
const getHelperText = (email) => {
  const { status, sent_at, error_message, scheduled_send_at } = email;

  if (status === EMAIL_STATUS.SENT && sent_at) {
    return formatEmailTimestamp(sent_at);
  }

  if (status === EMAIL_STATUS.FAILED) {
    return (
      error_message ||
      "Something went wrong during sending. Please copy the content to send manually via your mailbox, or report the issue to us."
    );
  }

  if (status === EMAIL_STATUS.PENDING && scheduled_send_at) {
    return `Scheduled for ${formatEmailTimestamp(scheduled_send_at)}`;
  }

  if (status === EMAIL_STATUS.SENDING) {
    return "Sending...";
  }

  if (status === EMAIL_STATUS.READY) {
    return "Ready to send";
  }

  return "";
};

const EmailCard = ({
  email,
  onCopyContent,
  onSendNow,
  onContactForHelp,
  onViewReport,
  isSending = false,
}) => {
  const { id, name, status, event_type: eventType } = email;
  const helperText = getHelperText(email);

  const renderActions = () => {
    if (status === EMAIL_STATUS.FAILED) {
      return (
        <div className="email-activity-card-actions">
          <Button variant="primary" onClick={() => onCopyContent(email)}>
            Copy Content
          </Button>
          <Button
            variant="outline-secondary"
            onClick={() => onContactForHelp()}
          >
            Contact for Help
          </Button>
        </div>
      );
    }

    if (status === EMAIL_STATUS.READY) {
      return (
        <div className="email-activity-card-actions">
          <Button
            variant="primary"
            onClick={() => onSendNow(id)}
            disabled={isSending}
          >
            {isSending ? "Sending..." : "Send Now"}
          </Button>
          {eventType === "report_delivery" && (
            <Button variant="outline-primary" onClick={() => onViewReport()}>
              View Report
            </Button>
          )}
        </div>
      );
    }

    return null;
  };

  return (
    <div className="email-activity-card">
      <EmailStatusIcon
        status={status}
        size={1}
        color={getStatusColor(status)}
        className="email-activity-card-icon"
      />
      <div className="email-activity-card-content">
        <div className="email-activity-card-top">
          <span className="email-activity-card-name">{name}</span>
          <StatusBadge status={status} />
        </div>
        {helperText && (
          <span className="email-activity-card-helper">{helperText}</span>
        )}
        {renderActions()}
      </div>
    </div>
  );
};

export default EmailCard;
